import Address from "@/classes/global/Address";
import ValidatedField from "@/classes/global/ValidatedField";


export default class PurchaseOrder {

    constructor() {

        this.openAddressModal = false;
        this.openOrderStatusModal = false;
        this.openItemDetailsModal = false;

        this.addressSelection = {

            supplier: {
                active: true,
                complete: false,
                isValid: true
            },
            consignee: {
                active: false,
                complete: false,
                isValid: true
            },
            agent: {
                active: false,
                complete: false,
                isValid: true
            }
        }

        this.currentTile = 'supplier';
        this.isEdit = false;
        this.isNew = true;
        this.companyId = '';
        this.currentEditAddress = {};

        this.supplier = new Address();
        this.consignee = new Address();
        this.agent = new Address();

        this.orderStatusList = [];
        this.itemDetailsList = [];

        this.metaData = {

            validatedFields: [

                new ValidatedField('companyName', true, true, 'Supplier Name', 'supplier'),
                new ValidatedField('addressLine1', true, true, 'Address Line 1', 'supplier'),
                new ValidatedField('addressLine2', false, false, 'Address Line 2', 'supplier'),
                new ValidatedField('city', false, false, 'city', 'supplier'),
                new ValidatedField('postCode', false, false, 'Post Code', 'supplier'),
                new ValidatedField('county', false, false, 'county', 'supplier'),
                new ValidatedField('country', false, false, 'Country', 'supplier'),

                new ValidatedField('companyName', true, true, 'Supplier Name', 'consignee'),
                new ValidatedField('addressLine1', true, true, 'Address Line 1', 'consignee'),
                new ValidatedField('addressLine2', false, false, 'Address Line 2', 'consignee'),
                new ValidatedField('city', true, false, 'city', 'consignee'),
                new ValidatedField('postCode', false, false, 'Post Code', 'consignee'),
                new ValidatedField('county', false, false, 'county', 'consignee'),
                new ValidatedField('country', false, false, 'Country', 'consignee'),

                new ValidatedField('companyName', true, true, 'Supplier Name', 'agent'),
                new ValidatedField('addressLine1', true, true, 'Address Line 1', 'agent'),
                new ValidatedField('addressLine2', false, false, 'Address Line 2', 'agent'),
                new ValidatedField('city', false, false, 'city', 'agent'),
                new ValidatedField('postCode', true, false, 'Post Code', 'agent'),
                new ValidatedField('county', false, false, 'county', 'agent'),
                new ValidatedField('country', false, false, 'Country', 'agent'),

            ]
        }


    }

}

